import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import {
  secondaryFont, wMBold, wMedium, wLight, maxWidth, retina,
} from 'Utils/utilsStyle';

const Wrapper = styled.div<{ color: string }>`
 .bulletItem {
  font-size: 16px;
  font-family: ${secondaryFont};
  line-height: 20px;
  padding-left: 15px;
  position: relative;
  @media all and (max-width: ${maxWidth}) , ${retina} {
   font-size: 14px;
  }
  &::before {
    background-color: ${(props) => props.color};
    content: '';
    height: 7px;
    width: 7px;
    border-radius: 50%;
    position: absolute;
    left: 0px;
    top: 7px;
  }
  .bullet-head {
    color: #000;
    font-weight: ${wMBold};
  }
  .bullet-body {
    color: rgba(66, 75, 80, 1);
    font-weight: ${wMedium};
  }
 }
 &.painPointsDesk {
    &:last-child {
      .bulletItem {
        margin-bottom: 0px;
      }
    }
  .bulletItem {
    padding-left: 25px;
    margin-bottom: 30px;
    &::before {
      height: 5px;
      width: 5px;
      background-color: #000;
      left: 10px;
    }
  }
  .bullet-body {
    font-weight: ${wLight};
  }
 }
`;

type Props = {
  color?: string;
  listHeading?: string;
  listDescription?: string;
  swatTabFlag?: boolean;
  expandSwotFlag?: boolean;
} & typeof defaultProps;

const defaultProps = {
  color: '',
  listHeading: '',
  listDescription: '',
  swatTabFlag: false,
  expandSwotFlag: true,
};

const BulletListItem = function BulletListItem(props: Props) {
  const {
    color, listHeading, listDescription, swatTabFlag, expandSwotFlag,
  } = props;
  return (
    <Wrapper color={color} className={classNames('bullet-list-item', { painPointsDesk: swatTabFlag, textTruncateThreeLine: !expandSwotFlag })}>
      <div className="bulletItem">
        <span className="bullet-head">
          {`${listHeading}: `}
        </span>
        <span className="bullet-body">
          {listDescription}
        </span>
      </div>
    </Wrapper>
  );
};

BulletListItem.defaultProps = defaultProps;
export default BulletListItem;
